import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=0a207e72&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=0a207e72&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../tmp/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a207e72",
  null
  
)

export default component.exports